/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const SectorAllocationContext = createContext({});
export default SectorAllocationContext;
